import React, { useMemo } from 'react'
import { I18n, hooks } from '@front/volcanion'
import TimeUtils from '@front/volcanion/utils/time'

import moment from 'moment'

import { Chip, TableCell, Box, Icon } from '@mui/material'

import { TextCell } from '@abra/elements/table/cells/basics/'
import { OrderLink, DriverLink, UserLink } from '@abra/elements'

const Row = ({ row }) => {
  const order = row?.order || row?.job?.first_step?.order
  const operator_id = row?.processor_usertype === 'operator' ? row?.processed_by : row?.operator
  const driver_id = row?.processor_usertype === 'driver' ? row?.processed_by : row?.driver
  const [{ name: operator_name }] = hooks.useCustomerInfo(operator_id)
  const [{ name: driver_name }] = hooks.useCustomerInfo(driver_id)
  const [{ name: client_name }] = hooks.useCustomerInfo(order?.do)

  const { status, color } = useMemo(() => {
    if (row.active === 1) return { status: 'event.keys.active', color: 'warning' }
    if (row.action === 'approve' && !!row.processedAt) return { status: 'event.keys.approve', color: 'success' }
    else if (row.action === 'refuse' && !!row.processedAt) return { status: 'event.keys.refuse', color: 'error' }
    else return { status: 'event.keys.canceled', color: 'error' }
  }, [])

  return (
    <>
      <TableCell size={'small'}><TextCell value={I18n.t(`event.${row.name}`)} /></TableCell>
      <TableCell size={'small'}>
        <Box display='flex' alignItems='center' justifyContent={'center'}>
          <Icon color='primary'>{'event'}</Icon>
          <TextCell sx={{ ml: 1 }} value={TimeUtils.getFormat(row.producedAt, 'calendar')} />
        </Box>
      </TableCell>
      <TableCell size={'small'}>
        {row?.driver ? (
          <DriverLink record_id={row.driver}>
            <TextCell value={driver_name} />
          </DriverLink>
        ) : '-'}
      </TableCell>
      <TableCell size={'small'}>
        {order?.do ? (
          <UserLink record_id={order.do}>
            <TextCell value={client_name} />
          </UserLink>
        ) : '-'}
      </TableCell>
      <TableCell size={'small'}>
        {order ? (
          <OrderLink record_id={order.order_id}>
            <TextCell value={order.client_id} />
          </OrderLink>
        ) : '-'}
      </TableCell>
      <TableCell size={'small'}>
        <Chip label={I18n.t(status)} variant='outlined' color={color} />
      </TableCell>
      <TableCell size={'small'}>
        <TextCell value={TimeUtils.getFormat(row.processedAt, 'calendar')} />
      </TableCell>
      <TableCell size={'small'}>
        <TextCell value={TimeUtils.secondsToTime(moment(row?.processedAt).diff(moment(row?.producedAt), 'seconds'))} />
      </TableCell>
      <TableCell size={'small'}>
        <TextCell value={operator_name} />
      </TableCell>
    </>
  )
}

export default React.memo(Row)
